import { UserType } from "app/types/userType";
import { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import ModalContents from "./components/ModalContents/ModalContents";
import ModalHeader from "./components/ModalHeader/ModalHeader";
import "./LossLimitsFormModal.scss";

type LossLimitsFormModalProps = {
  user: UserType;
  toggleLossLimitsModal: (
    showLossLimitsModal: boolean,
    username: string
  ) => void;
  showLossLimitsModal: boolean;
};

const LossLimitsFormModal = ({
  user,
  toggleLossLimitsModal,
  showLossLimitsModal,
}: LossLimitsFormModalProps): JSX.Element => {
  const [hasModalBeenOpened, setHasModalBeenOpened] = useState(false);

  useEffect(() => {
    if (
      user?.promptedForLossLimits &&
      !showLossLimitsModal &&
      !hasModalBeenOpened
    ) {
      toggleLossLimitsModal(user.promptedForLossLimits, user.username);
      setHasModalBeenOpened(true);
    }
  }, [user?.promptedForLossLimits, showLossLimitsModal, hasModalBeenOpened]);

  if (!showLossLimitsModal) return null;

  return (
    <div className="loss-limits-form-modal__overlay">
      <div className="loss-limits-form-modal__placeholder">
        <div className="loss-limits-form-modal">
          <ModalHeader />
          <ModalContents />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.userModel.user,
  showLossLimitsModal: state.lossLimitsModel.showLossLimitsModal,
});

const mapDispatchToProps = dispatch => ({
  toggleLossLimitsModal: (showLossLimitsModal: boolean, username: string) =>
    dispatch.lossLimitsModel.toggleLossLimitsModal({
      showLossLimitsModal,
      username,
    }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(LossLimitsFormModal));
